import { render, staticRenderFns } from "./RefundDrawer.vue?vue&type=template&id=2b80a9bb&scoped=true&"
import script from "./RefundDrawer.vue?vue&type=script&lang=js&"
export * from "./RefundDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RefundDrawer.vue?vue&type=style&index=0&id=2b80a9bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80a9bb",
  null
  
)

export default component.exports